import { Modal } from "react-bootstrap";
import { Button } from "../../components/button";
import { useTranslation } from "react-i18next";
import { IQdsRequest } from "../../entities/IQdsRequest";

interface GiveConsentModalProps {
  isVisible: boolean;
  qdsRequest: IQdsRequest | null;
  onDismiss: () => void;
  onApprove: () => Promise<void>;
  onReject: () => Promise<void>;
  isLoading: boolean;
}

export function GiveConsentModal({
  isVisible,
  qdsRequest,
  onDismiss,
  onApprove,
  onReject,
  isLoading,
}: GiveConsentModalProps) {
  const { t } = useTranslation();

  if (!qdsRequest) {
    return null;
  }

  return (
    <Modal show={isVisible} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="giveConsentModal">
          {t("DOCUMENTS.GIVE_CONSENT_TITLE", { requestId: qdsRequest.id })}
        </h5>
        <button type="button" className="icon-button" onClick={onDismiss} aria-label={t("CANCEL_BUTTON")}>
          <span className="font-20 cursor-pointer">&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <p>
          {t("DOCUMENTS.GIVE_CONSENT_LABEL", { requestId: qdsRequest.id })}
        </p>
      </Modal.Body>
      <Modal.Footer className="d-flex gap-2">
        <Button
          className="btn btn-success"
          onClick={onApprove}
          disabled={isLoading}
          isLoading={isLoading}
          loader={{ size: "s" }}
        >
          {t("DOCUMENTS.APPROVE")}
        </Button>
        <Button
          className="btn btn-danger"
          onClick={onReject}
          disabled={isLoading}
          isLoading={isLoading}
          loader={{ size: "s" }}
        >
          {t("DOCUMENTS.REJECT")}
        </Button>
        <Button
          className="btn btn-neutral"
          onClick={onDismiss}
          disabled={isLoading}
        >
          {t("CANCEL_BUTTON")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
